module.exports = __webpack_public_path__ + "static/media/vegan.aa4e6833.svg";